<template>
    <li class="list-group-item list-group-item-secondary list-bg">
     <div v-if="!editMode">
       <b-button variant="default" class=" float-right float-top" @click="removeFilm(`${film.id}`)">
          <span class="bi-x-circle" aria-hidden="true"></span>
      </b-button>
      <p class="font-weight-bold"><span v-if="film.sendereiheId">{{findSendung(film.sendereiheId).name}}, </span>{{film.titel}}</p>
      <p> {{showLaenge(film)}}, {{findSender(film.senderId).name}}</p>
    </div>
   <div v-if="editMode">
     <div class="row">
    <div class="col-xs-12 col-md-8">
    <b-form-group
        id="input-group-1"
        label="Titel"
        label-for="input-1">
         <b-form-input id="input-1" v-model="film.titel" type="text" required placeholder="Den Titel eingeben..."/>
    </b-form-group>
    </div>
     <div class="col-xs-12 col-md-4">
      <b-form-group
          id="input-group-14"
          label="Sendereihe"
          label-for="input-14">
            <b-form-select
              id="input-14"
              v-model="film.sendereiheId">
              <option :value="0">Ohne Sendereihe</option>
              <option v-for="(sendung, id) in sendereihen" v-bind:key="id" :value="sendung.id">{{sendung.name}}</option>
            </b-form-select>
      </b-form-group>
    </div>
   </div>
    <div class="row">
      <div class="col-xs-12 col-md-3">
        <b-form-group
            id="input-group-11"
            label="Jahr"
            label-for="input-11">
              <b-form-select
                id="input-11"
                v-model="film.jahr"
                required>
                <option v-for="(year, id) in yearValues"  v-bind:key="id" :value="year">{{year}}</option>
              </b-form-select>
        </b-form-group>
      </div>
      <div class="col-xs-12 col-md-3">
        <b-form-group
            id="input-group-12"
            :label="lenGroupLabel"
            label-for="input-12">
            <b-input-group >
            <b-form-input  id="input-12" v-model="film.laenge" required list="laenge-list-id"></b-form-input>
            <datalist id="laenge-list-id">
                 <option v-for="laenge in laengeValues" v-bind:key="laenge">{{laenge}}</option>
            </datalist>
            <b-form-select v-model="film.lenTyp" :options="len_options"></b-form-select>
            </b-input-group>
        </b-form-group>
      </div>
      <div class="col-xs-12 col-md-3">
        <b-form-group
            id="input-group-13"
            label="Kategorie"
            label-for="input-13">
              <b-form-select
                id="input-13"
                v-model="kategorie"
                @change="switchSender"
                required>
                <option v-for="(sk, id) in categories" v-bind:key="id" :value="sk.id">{{sk.name}}</option>
              </b-form-select>
        </b-form-group>
      </div>
      <div class="col-xs-12 col-md-3">
        <b-form-group
            id="input-group-14"
            :label="senderLabel"
            label-for="input-14">
              <b-form-select
                id="input-14"
                v-model="film.senderId"
                @change="switchSendereihen"
                required>
                <option v-for="(sender, id) in senderListe" v-bind:key="id" :value="sender.id">{{sender.name}}</option>
              </b-form-select>
        </b-form-group>
      </div>
    </div>
    </div>
    </li>
</template>
<script>
import utils from '@/utilities'
import api from '@/api/benutzer'

export default {
  name: 'FilmografieEntry',
  props: ['user', 'profil', 'film', 'editMode'],
  watch: {
    film: function (newFilm, oldFilm) {
      if (!newFilm.sendereiheId) {
        newFilm.sendereiheId = 0
      }
    }
  },
  mounted () {
    this.updateFilm(this.$props.film)
  },
  methods: {
    findSendung (sendungid) {
      let sendung = this.$store.state.auth.baseData.sendungen.filter(sendung => (sendung.id === sendungid))
      if (sendung && sendung.length > 0) {
        return sendung[0]
      }
      return {}
    },
    updateFilm (film) {
      let sender = this.findSender(film.senderId)
      if (!film.sendereiheId) {
        film.sendereiheId = 0
      }
      this.kategorie = sender.kategorieId
      this.switchSender()
      this.switchSendereihen()
    },
    showLaenge (film) {
      return film.laenge + ' ' + film.lenTyp
    },
    async removeFilm (id) {
      if (confirm('Wollen Sie diesen Eintrag entfernen?')) {
        await api.deleteFilm(this.user.id, id)
        let user = await api.get(this.user.id)
        this.$bubble('userchanged', user)
      }
    },
    findSender (senderid) {
      for (let senderCat in this.$store.state.auth.baseData.sender) {
        for (let i = 0; i < this.$store.state.auth.baseData.sender[senderCat].length; i++) {
          if (this.$store.state.auth.baseData.sender[senderCat][i].id === senderid) {
            return this.$store.state.auth.baseData.sender[senderCat][i]
          }
        }
      }
      return {name: 'unbekannter Sender', id: 0}
    },
    switchSender () {
      if (this.kategorie) {
        this.senderListe = this.$store.state.auth.baseData.sender[this.kategorie]
        if (this.categories[this.kategorie]) {
          this.senderLabel = this.categories[this.kategorie].senderLabel
        }
      } else {
        this.senderListe = []
      }
    },
    findGenre (genreid) {
      for (let i = 0; i < this.genres.length; i++) {
        // eslint-disable-next-line
        if (this.genres[i].id == genreid) {
          return this.genres[i]
        }
      }
      return {}
    },
    switchSendereihen () {
      let genre = this.findGenre(this.film.genreId)
      if (this.film.senderId) {
        this.sendereihen = this.$store.state.auth.baseData.sendungen.filter(sendung => (sendung.formatId === genre.formatId && sendung.senderId === this.film.senderId))
      } else {
        this.sendereihen = []
      }
    },
    async onEdit (event) {
      event.preventDefault()
    },
    async onSubmit (event) {
      event.preventDefault()
      let httpForm = new FormData()
      for (let [key, value] of Object.entries(this.form)) {
        httpForm.append(key, value)
      }
      let result = await api.addFilm(this.user.id, httpForm)
      if (!result.errorMessage) {
        let user = await api.get(this.user.id)
        this.$bubble('userchanged', user)
        this.kategorie = null
      }
    },
    onReset (event) {
      event.preventDefault()
      // Reset our form values
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    categorySort (c1, c2) {
      let w1 = c1.weight
      let w2 = c2.weight
      return w1 - w2
    },
    filtered ($cats) {
      let cats = []
      // eslint-disable-next-line
      for (const [key, value] of Object.entries(this.$store.state.auth.baseData.senderCategories)) {
        if (value.anzeigenFilmografie) {
          cats.push(value)
        }
      }
      return cats.sort(this.categorySort)
    }
  },
  computed: {
    lenGroupLabel () {
      switch (this.film.lenTyp) {
        case 'min':
          return 'Länge'
        case 'items':
          return 'Anzahl'
        default:
          return 'Eingabe erforderlich'
      }
    }
  },
  data () {
    return {
      senderLabel: 'Sender',
      genres: this.$store.state.auth.baseData.genres,
      senderListe: [],
      sendereihen: [],
      kategorie: null,
      categories: this.filtered(this.$store.state.auth.baseData.senderCategories),
      len_options: ['min', 'items'],
      laengeValues: utils.laengeValues(),
      yearValues: utils.yearValues()
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/vue/components/profil/FilmografieEntry.vue